<script lang="ts">
    import { onMount } from 'svelte';
    import type { TileListInitialSession } from '@tilelist/application/core/TileListInitialSession.ts';
    import { createAndProvideWiring, mountWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import TileList from '@tilelist/components/tile-list/TileList.svelte';
    import { FallbackTileListStrategy } from '@tilelist/domain/composition/strategies/FallbackTileListStrategy.ts';

    type Props = {
        initialSession: TileListInitialSession;
    };

    const { initialSession }: Props = $props();

    /*                                     */
    const wiringCtx = createAndProvideWiring(initialSession);

    onMount(
        () =>
            mountWiring(
                wiringCtx,
                initialSession,
                () => {
                    /*                                                              */
                },
                () => new FallbackTileListStrategy(),
            ).cleanup,
    );

    const rule = $derived(initialSession.page.context.rule);
    const assortment = $derived(initialSession.page.context.searchContext?.topNImplicit?.assortmentNavigation?.[0]);
</script>

<!-- NOTE: id=reptile-tilelist-bracket is still used by Darwin -->
<div
    id="reptile-tilelist-bracket"
    data-rule={rule}
    data-assortment={assortment}
    data-origin="dundee"
    data-qa="reptile-errorPage"
>
    <oc-banner-v1 variant="hint" size={'100'} hide-close-button icon-type="info-hint">
        Hoppla, deine gewünschten Artikel finden wir nicht mehr. Hier findest du Artikel, die dir auch gefallen könnten.
    </oc-banner-v1>
    <TileList
        tileListItems={initialSession.page.tileListItems}
        context={initialSession.page.context}
        featureIndexOffset={0}
    />
</div>
